import { PoComboOption } from "@po-ui/ng-components";
import { FiltroLista, IFiltroLista } from "src/app/filter/filtro-lista";


export interface IFiltroDadosParceiroDeNegocio extends IFiltroLista {

  DULTCOM: Date | undefined;
  DATU: Date | undefined;
  CFORNECEDORLOJA: string;
  CCLIENTELOJA: string;
  CTIPO:  'C' | 'F' | ' '; // 'C' para Cliente, 'F' para Fornecedor
}

export class FiltroDadosParceiroDeNegocio extends FiltroLista {
  dados: IFiltroDadosParceiroDeNegocio = this.setDefault();
  timeout = this.getDataString();


  public readonly tipoOrigemPoComboOptions: Array<PoComboOption> = [
    { label: 'Cliente', value: 'C' },
    { label: 'Fornecedor', value: 'F' },
  ]

  public setDefault(): IFiltroDadosParceiroDeNegocio {
    return {
      page: 1,
      pageSize: 20,
      filter: '',
      order: '',
      CFORNECEDORLOJA: '',
      CCLIENTELOJA: '',
      DULTCOM: this.getData(-365),
      DATU: undefined ,
      CTIPO: ' '
    };
  }
}
